"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isInRange(value, options) {
    const { from, to, factor = 100000 } = options;
    return value * factor >= from * factor && value * factor <= to * factor;
}
exports.default = isInRange;
